import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { IGlobalTablesService } from "@suite/common/interfaces/i-global-tables-service";
import { LanguageSettings } from "@suite/common/services/language-settings";
import { Title } from "@angular/platform-browser";
import { Params } from '@angular/router';
import { DataStore } from './common/data-models/data-store/data-store';
import { APP_THEMES_MAP, DARK_MODE_KEY } from '@common/enums/constants';
import { VisualStateService } from '@common/services/visual-state-service';
import { NomWebServicesJson } from './common/services/nom-web-services-json';
import { PersonalSettings, PersonalSettingsService } from './common/services/personal-settings-service';


@Injectable({ providedIn: 'root' })
export class AppTheme {

    public static globalTablesService: IGlobalTablesService;
    //TODO: FIGURE THIS OUT
    public darkColor: string = '#00363A';
    public wrapperTopBarCollorsMap = {
        'playbook': '#00363A',
        'login': '#000000',
    };

    private renderer: Renderer2;

    constructor(
        private rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private document: Document,
        public languageSettings: LanguageSettings,
        public titleService: Title,
        private visualStateService: VisualStateService,
        private nomWebServicesJson: NomWebServicesJson,
        private personalSettingsService: PersonalSettingsService
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
        if (this.visualStateService.userPreffersDarkMode) {
            this.setDarkMode();
        }

    }

    public applyTheme(appName: string, routeParams?: Params) {

        const appNameKey = appName.toLowerCase();

        this.setIOSColor(this.wrapperTopBarCollorsMap['playbook'])
        const body = this.document.body;
        for (let key in APP_THEMES_MAP) {
            const appDarkThemeKey = `${APP_THEMES_MAP[key]}-${DARK_MODE_KEY}`;
            this.renderer.removeClass(body, APP_THEMES_MAP[key]);
            this.renderer.removeClass(body, appDarkThemeKey);
        }
        if (this.nomWebServicesJson.HelloResults.DarkMode) {
            this.renderer.addClass(body, `${APP_THEMES_MAP[appNameKey]}-${DARK_MODE_KEY}`);
        } else {
            this.renderer.addClass(body, APP_THEMES_MAP[appNameKey]);
        }
        this.setTitle(appName, AppTheme.globalTablesService.StorytellingNavigation.length, routeParams);
    }

    public setIOSColor(color) {
        if (window["webkit"] && window["webkit"].messageHandlers && window["webkit"].messageHandlers.interOp && window["webkit"].messageHandlers.interOp.postMessage) {
            window["webkit"].messageHandlers.interOp.postMessage({ "name": "changeColor", "color": color });
        }
    }

    public setTitle(appName: string, storytellingProductsCount: number = AppTheme.globalTablesService.StorytellingNavigation.length, routeParams?: Params) {
        let appTitle = "";
        appTitle = this.languageSettings.PSTWebApPlaybookTitleLabel;
        if (storytellingProductsCount && storytellingProductsCount > 1) {
            appTitle = this.languageSettings.PSTWebApStorytellingTitleLabel;
            if (appName) {
                switch (appName.toUpperCase()) {
                    case "PLAYBOOK":
                        appTitle = this.languageSettings.PSTWebApStorytellingTitleLabel + ": " + this.languageSettings.PSTWebPlaybookTitleLabel;
                        break;
                    case "CAST":
                        appTitle = this.languageSettings.PSTWebApStorytellingTitleLabel + ": " + this.languageSettings.PSTWebCastTitleLabel;
                        break;
                    case "DISCOVER":
                        appTitle = this.languageSettings.PSTWebApStorytellingTitleLabel + ": " + this.languageSettings.PSTWebDiscoverTitleLabel;
                        break;
                    case "EMBEDDED":
                        const appId = routeParams.id;
                        appTitle = this.languageSettings.PSTWebApStorytellingTitleLabel
                        if (appId) {
                            const appEntry = AppTheme.globalTablesService.StorytellingNavigation.filter((item) => item.ID.toUpperCase() == appId.toUpperCase())
                            if (appEntry && appEntry.length > 0) {
                                appTitle += ": " + appEntry[0].Name;
                                DataStore.appService.applicationEmbeddedName = appEntry[0].Name;
                            }
                        }
                        break;
                    default:
                        appTitle = this.languageSettings.PSTWebApStorytellingTitleLabel;
                        break;
                }
            }
        }
        this.titleService.setTitle(appTitle);
    }

    async toggleDarkMode() {
        if (this.nomWebServicesJson.HelloResults.DarkMode) {
            this.setLightMode();
            const settings: PersonalSettings = {
                DarkMode: false
            }
            this.nomWebServicesJson.HelloResults.DarkMode = false;
            await this.personalSettingsService.updatePersonalSettings(settings);
        } else {
            this.setDarkMode();
            const settings: PersonalSettings = {
                DarkMode: true
            }
            this.nomWebServicesJson.HelloResults.DarkMode = true;
            await this.personalSettingsService.updatePersonalSettings(settings);
        }
        localStorage.setItem("GlobalsHelloResults", JSON.stringify(this.nomWebServicesJson.HelloResults));
    }

    private async setLightMode() {
        const body = this.document.body;
        const appDarkThemeKey = `${APP_THEMES_MAP['playbook']}-${DARK_MODE_KEY}`;
        const appThemeKey = `${APP_THEMES_MAP['playbook']}`;
        this.renderer.removeClass(body, appDarkThemeKey);
        this.renderer.addClass(body, appThemeKey);
    }

    private async setDarkMode() {
        const body = this.document.body;
        const appDarkThemeKey = `${APP_THEMES_MAP['playbook']}-${DARK_MODE_KEY}`;
        const appThemeKey = `${APP_THEMES_MAP['playbook']}`;
        this.renderer.removeClass(body, appThemeKey);
        this.renderer.addClass(body, appDarkThemeKey);
    }

}
